import { useState, useCallback } from "react";
import { uploadData } from "aws-amplify/storage";
// Mock implementation of blobUrlToFile and uploadData
async function blobUrlToFile(blobUrl, fileName) {
  // Fetch the blob data from the blob URL
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  // Create a File object from the blob
  const file = new File([blob], fileName, {
    type: blob.type,
    lastModified: Date.now(),
  });

  return file;
}

const useUploadMasterFile = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadMasterFile = useCallback(async (item) => {
    setLoading(true);
    setError(null);
    try {
      const filePath = item.filePath;
      const uuid = item.masterFile.split("/").pop();
      const response = await blobUrlToFile(item.masterFile, uuid);
      await uploadData({ key: filePath, data: response }).result;
    } catch (error) {
      setError(error);
      console.error("An error occurred during the upload process:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { uploadMasterFile, loading, error };
};

export default useUploadMasterFile;
